/**
 * Theme toggle component for switching between light and dark mode
 */

import { useTheme } from '@/contexts/ThemeContext';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Moon, Sun } from 'lucide-react';

interface ThemeToggleProps {
  showLabel?: boolean;
  className?: string;
}

export function ThemeToggle({ showLabel = true, className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className={`flex items-center justify-between gap-3 ${className || ''}`}>
      {showLabel && (
        <div className="flex items-center gap-2">
          {isDark ? (
            <Moon className="h-4 w-4 text-muted-foreground" />
          ) : (
            <Sun className="h-4 w-4 text-muted-foreground" />
          )}
          <Label htmlFor="theme-toggle" className="cursor-pointer text-sm font-medium">
            Dark Mode
          </Label>
        </div>
      )}
      <Switch id="theme-toggle" checked={isDark} onCheckedChange={toggleTheme} />
    </div>
  );
}
